import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { downgradeComponent } from '@angular/upgrade/static';
import App from '@app/app';
import { LtLookImageComponent } from '@app/components/core/lt-look-image/lt-look-image.component';
import type { LookImage } from '@app/interface/image/look-image.interface';

/**
 * Circular avatar for a subject's portrait look. Owns the "portrait → circle"
 * framing (`fit="cover"` + `focus="top"`) so consumers never reach into
 * `lt-resolved-image`'s styling.
 *
 * Size the host directly from the consumer (`lt-avatar { inline-size: … }`).
 * The error fallback is disabled: a look that fails to resolve collapses the
 * host to nothing (via `:has()`) instead of leaving an empty circle.
 */
@Component({
  selector: 'lt-avatar',
  standalone: true,
  imports: [LtLookImageComponent],
  templateUrl: './lt-avatar.component.html',
  styleUrl: './lt-avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LtAvatarComponent {
  readonly lookImage = input.required<LookImage>();
  readonly testId = input.required<string>();
  /** Alt text for the portrait; empty string (default) marks it decorative. */
  readonly altFallback = input('');
}

App.directive('ltAvatar', downgradeComponent({ component: LtAvatarComponent }));
